import { createContext, useContext } from 'react'

import { realtimeManager } from './instance'
import type { RealtimeManager } from './manager'

export const RealtimeContext = createContext<RealtimeManager>(realtimeManager)

export function useRealtimeManager(): RealtimeManager {
  return useContext(RealtimeContext)
}
